import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";

export interface GtmEvent {
    event: string;
    value: {
        event_name: string;
        widget: string;
        href?: string;
        meta_data: Record<string, unknown>;
        page_path?: string;
        referral_page?: string;
    };
}

/**
 * Returns an object containing the GTM event data for a main navigation click.
 *
 * @param {string} text - The text of the clicked navigation item.
 * @return {GtmEvent} An object containing the GTM event data.
 */
export const getEventNavigationData = (
    text: string,
): GtmEvent => {
    const eventData: GtmEvent = {
        event: "user_interaction",
        value: {
            event_name: GTM_EVENT_NAMES.MAIN_NAVIGATION,
            widget: "sticky_header",
            meta_data: {
                click_text: text,
            },
        },
    };

    return eventData;
};

export const getFooterLinkEventData = (
    text: string
): GtmEvent => {
    const eventData: GtmEvent = {
        event: "user_interaction",
        value: {
            event_name: "footer_navigation",
            widget: "footer_link",
            meta_data: {
                click_text: text,
            },
        },
    };

    return eventData;
};
